var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.formKey === 'campaign_name' && !_vm.formItem.isPreview)?_c('div',_vm._l((_vm.formItem.word_list),function(word){return _c('el-link',{key:word,staticClass:"mr-10",attrs:{"underline":false,"type":"primary"},on:{"click":function($event){return _vm.insertWord(`{${word}}`, _vm.formItem)}}},[_vm._v("+"+_vm._s(word))])}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }